export default __webpack_public_path__ + "static/media/purple_rank.33dda272.png";